class Category {
	constructor({ id, name } = {}) {
		this._id = id;
		this._name = name;
	}

	static buildFromJSON(json) {
		return new Category({
			id: json.id,
			name: json.name
		});
	}

	get id() {
		return this._id;
	}

	get name() {
		return this._name;
	}
}

export default Category;
